import React from 'react'
import { useTranslation } from 'react-i18next'

import './UploadImage.scss'

const UploadImage = ({ label = '', value, onUpdate, openAssetManager, isDisabled, isDisabledDelete }) => {
    const { t } = useTranslation()
    const onUpload = () => {
        openAssetManager(data => {
            onUpdate(data.src)
        })
    }

    const onDelete = () => {
        onUpdate('')
    }

    return (
        <div className={`common-upload-image-group ${isDisabled ? 'is-disabled' : ''}`}>
            {label.length ? <p className="common-upload-image-group__label">{label}</p> : null}
            <div className="common-upload-image-group__content">
                {value ? (
                    <div
                        className="common-upload-image-group__img-preview"
                        style={{ backgroundImage: `url(${value})` }}
                    />
                ) : null}
                <button className="common-upload-image-group__contr-btn" onClick={() => onUpload()}>
                    {value ? t('Change') : t('Upload')}
                </button>
                {value && !isDisabledDelete ? (
                    <button className="common-upload-image-group__delete-btn" onClick={() => onDelete()} />
                ) : null}
            </div>
        </div>
    )
}

export default UploadImage
